import React from 'react';
import FilterListColumn from '~/components/Search/FilteringList/FilterListColumn';

function FilteringListContainer({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return <FilterListColumn className={className}>{children}</FilterListColumn>;
}

export default FilteringListContainer;
